// extracted by mini-css-extract-plugin
export default {"main":"HomeLayout_main__QGDGb","container":"HomeLayout_container__-QnSS"};